import React from "react";
import Sidebar from "../sidebar/Sidebar";

const Dashboard = () => {
  return (
    <div>
      <Sidebar />
    </div>
  );
};

export default Dashboard;
